export const PHOTO_MIME = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'] as const
export const MAX_PHOTO_BYTES = 30 * 1024 * 1024

const BY_EXTENSION: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  heic: 'image/heic',
  heif: 'image/heif',
}

/** The MIME type to upload with: a known browser type, else by extension (browsers report '' for HEIC); null if unsupported. */
export function mimeOf(name: string, type: string): string | null {
  const known = (PHOTO_MIME as readonly string[]).indexOf(type) >= 0
  if (known) return type
  if (type) return null
  const dot = name.lastIndexOf('.')
  return dot < 0 ? null : BY_EXTENSION[name.slice(dot + 1).toLowerCase()] ?? null
}

export function photoFileProblem(name: string, size: number, type: string): 'Photos_upload_bad_type' | 'Photos_upload_too_large' | null {
  if (!mimeOf(name, type)) return 'Photos_upload_bad_type'
  return size > MAX_PHOTO_BYTES ? 'Photos_upload_too_large' : null
}

/** Runs `worker` over `items` with at most `limit` in flight; results keep the input order. */
export async function runPool<T, R>(items: T[], limit: number, worker: (item: T) => Promise<R>): Promise<R[]> {
  const results: R[] = new Array(items.length)
  let next = 0
  const lane = async () => {
    while (next < items.length) {
      const i = next++
      results[i] = await worker(items[i])
    }
  }
  const lanes: Promise<void>[] = []
  for (let i = 0; i < Math.min(limit, items.length); i++) lanes.push(lane())
  await Promise.all(lanes)
  return results
}

/** Files dragged in from the computer — not an internal photo drag (PHOTOS_DRAG_TYPE in PhotoTile), which also lists 'Files' in some browsers. */
export const isFileDrag = (types: readonly string[]): boolean =>
  types.indexOf('Files') >= 0 && types.indexOf('application/x-urkla-photos') < 0
